module.exports = __webpack_public_path__ + "build/desktop/img/view.ca9d11d96808cf6c9afb3cea884ddd95.svg";